//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BlogMenuItem from '~/components/section/blog-menu-item'
export default {
  name: 'BlogMenu',
  components: { BlogMenuItem },
  props: {
    categories: {
      type: Array,
      default: []
    },
    lang: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      menuState: false
    }
  }
}
